import { FC } from 'react';
import { ListCheckAnswerNoteLabel } from '../../styles';
import { OfferLetterFormTextarea } from '../offerLetterFormStyles';

interface ListCheckNoteFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
}

const ListCheckNoteField: FC<ListCheckNoteFieldProps> = ({ label, value, onChange }) => (
  <ListCheckAnswerNoteLabel>
    {label}
    <OfferLetterFormTextarea
      data-testid="list-check-answer-note"
      rows={4}
      maxLength={2000}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    />
  </ListCheckAnswerNoteLabel>
);

export default ListCheckNoteField;
